import _ from '@lodash';
import { useRef, useState, createContext, useContext, useEffect } from 'react';

import AspectEditService from 'app/admin/aspect/service/AspectEditService';

export const LabMeasurementReaderContext = createContext(null);

export const useLabMeasurementReader = () => {
    return useContext(LabMeasurementReaderContext);
};

export default function LabMeasurementReaderProvider(props) {
    const [type, setType] = useState('ComponentMassFrac');
    const [aspectId, setAspectId] = useState(null);
    const [aspectData, setAspectData] = useState(null);
    const [massOptionList, setMassOptionList] = useState([]);

    useEffect(() => {
        console.log('Get data for aspect id: ' + aspectId);

        if (aspectId !== null) {
            AspectEditService.getData(aspectId).then(data => {
                setAspectData(data);
            }).catch(e => { console.log(e); setAspectData(null); });
        } else {
            setAspectData(null);
        }
    }, [aspectId]);

    useEffect(() => {
        if (aspectData && aspectData.input_attributes)
            resolveMassOptionList();
    }, [aspectData]);

    const resolveMassOptionList = () => {
        let arr = [];
        for (let i = 0; i < aspectData.input_attributes.length; i += 1)
            if (aspectData.input_attributes[i].type === type)
                arr.push({ label: aspectData.input_attributes[i].name, value: aspectData.input_attributes[i].name });
        
        setMassOptionList(arr);
    };

    const getMassOptionList = () => {
        console.log(massOptionList);
        return new Promise(resolve => { resolve(massOptionList); });
    };

    const value = {
        type,
        setType,
        aspectId,
        setAspectId,
        aspectData,
        setAspectData,
        getMassOptionList
    };

    return <LabMeasurementReaderContext.Provider value={value}>{props.children}</LabMeasurementReaderContext.Provider>;
}